import React from "react";
import Headers from "./Headers";
import GroupMembersItem from "./GroupMembersItem";
import TablePagination from "components/Pagination/TablePagination";

const GroupMembersList = ({
  groupInvites,
  paginationProps,
  cancelInvitation,
  handleApprove,
}) => {
  return (
    <table>
      <Headers />
      {groupInvites.map((groupInvite) => (
        <GroupMembersItem
          key={groupInvite.id}
          groupInvite={groupInvite}
          cancelInvitation={cancelInvitation}
          handleApprove={handleApprove}
        />
      ))}
      <tr>
        <td colSpan="9">
          <TablePagination {...paginationProps} />
        </td>
      </tr>
    </table>
  );
};

export default GroupMembersList;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/GroupMembers/GroupMembersList.jsx